import React, { useState, useEffect } from "react";
import { MD5 } from "crypto-js";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { API_URL } from "./config";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/logo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordHash, setPasswordHash] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setPasswordHash(MD5(password).toString());
  }, [password]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire({
        text: "Please enter both email and password.",
        icon: "warning",
      });
      return;
    }

    setIsLoading(true);

    fetch(`${API_URL}/users/login/${email}/${passwordHash}`)
      .then((res) => res.json())
      .then((resp) => {
        if (resp.length === 1) {
          const user = resp[0];
          // Store user details in localStorage
          localStorage.setItem("user", JSON.stringify(user));
          navigate("/"); // Replace with your next page route
        } else {
          Swal.fire({
            text: "Incorrect Username or Password!",
            icon: "error",
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
        Swal.fire({
          text: "Login failed, check your network connection!",
          icon: "error",
        });
      });
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        padding: '20px'
      }}
    >
      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '450px',
          width: '100%'
        }}
      >
        <div className="text-center mb-4">
          <img 
            src={logo} 
            alt="Logo" 
            height="50" 
            className="mb-3"
            style={{
              filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
            }}
          />
        </div>
        <div
          className="card border-0"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            borderRadius: '20px',
            padding: '2rem'
          }}
        >
          <h2 
            className="text-center mb-4"
            style={{
              color: '#2d3436',
              fontSize: '2rem',
              fontWeight: '600'
            }}
          >
            XGo Life
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label 
                className="form-label"
                style={{
                  color: '#636e72',
                  fontWeight: '500',
                  fontSize: '0.9rem'
                }}
              >
                Email
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control form-control-lg"
                required
                style={{
                  border: '2px solid #e9ecef',
                  borderRadius: '12px',
                  padding: '0.75rem',
                  fontSize: '1rem',
                  backgroundColor: '#f8f9fa',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className="mb-4">
              <label 
                className="form-label"
                style={{
                  color: '#636e72',
                  fontWeight: '500',
                  fontSize: '0.9rem'
                }}
              >
                Password
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control form-control-lg"
                required
                style={{
                  border: '2px solid #e9ecef',
                  borderRadius: '12px',
                  padding: '0.75rem',
                  fontSize: '1rem',
                  backgroundColor: '#f8f9fa',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <button
              type="submit"
              className="btn btn-warning w-100 py-3 mb-3"
              disabled={isLoading}
              style={{
                borderRadius: '12px',
                fontSize: '1.1rem',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)'
              }}
            >
              {isLoading ? (
                <div className="d-flex align-items-center justify-content-center">
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Logging in...
                </div>
              ) : (
                'Login'
              )}
            </button>
          </form>
          <p 
            className="text-center mb-3"
            style={{
              color: '#636e72',
              fontSize: '0.95rem'
            }}
          >
            Don't have an account?{" "}
            <Link
              to="/TermsCondition"
              className="text-warning text-decoration-none fw-bold"
            >
              Create Account
            </Link>
          </p>
          <Link
            to="/forgot-password"
            className="text-primary d-block text-center text-decoration-none"
            style={{
              fontSize: '0.95rem',
              fontWeight: '500'
            }}
          >
            Forgot Password?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;